import {ReactText} from "react";
import {DataNode} from "rc-tree/lib/interface";

export const summarizeTree = (
  checkedLeafKeys: ReactText[],
  leafs: DataNode[],
  withoutFacilityName = false, // if true, return number of selected facilities
) => {
  if (checkedLeafKeys.length === 0) {
    return "None";
  }
  if (checkedLeafKeys.length === 1 && !withoutFacilityName) {
    const leaf = leafs.find(({key}) => key === checkedLeafKeys[0]);

    return leaf ? leaf.title : "";
  }
  if (checkedLeafKeys.length === leafs.length) {
    return "All";
  }

  return withoutFacilityName
    ? `(${checkedLeafKeys.length})`
    : `${checkedLeafKeys.length} selected`;
};

export const handleKeyDown =
  (handler: () => void) => (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handler();
    }
  };

export const excludeParentNodes = (
  keys: readonly string[],
  allLeafKeys: Set<string>,
) => keys.filter(checkedKey => allLeafKeys.has(checkedKey as string));
